import script from "./TheOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./TheOverlay.vue?vue&type=style&index=0&id=f248e794&scoped=true&lang=css"

import exportComponent from "/home/runner/work/app-registration/app-registration/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f248e794"]])

export default __exports__